<template>
  <v-dialog v-model="value" width="500px">
    <v-card>
      <v-card-title>必須データ入力</v-card-title>
      <v-card-text class="pb-0">
        <div class="red--text mb-2">AI MODEL A異常検知を実行するように、以下の項目が必須です。</div>
        <v-form
            ref="requiredDataForm"
        >
          <v-text-field
              type="number"
              v-model="requiredData.dc"
              label="DC量（kW）"
              :rules='[(v) => !!v || "DC量を入力してください。"]'
              dense
              outlined
              hide-details="auto"
          >
          </v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="cancel">キャンセル</v-btn>
        <v-btn @click="updateFolderProperty">確定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import {store} from "@/store";

export default {
  name: "AirprobeRequiredDataDialog",
  props: ['value', 'plantId'],
  data() {
    return {
      requiredData: {
        dc: 0
      }
    }
  },
  methods: {
    updateFolderProperty() {
      this.axios
          .put('/api/airprobe/update-required-data/' + this.plantId, this.requiredData)
          .then(() => {
            // this.$emit('sendAirprobeRequest');
            this.$emit('dcUpdated');
          })
          .catch(() => {
            store.showErrorDialog('エラーが発生しました。再度試してください。');
          });
    },
    close() {
      this.$emit('input');
    },
    cancel(){
      this.$emit('cancelUpdateDC');
      this.$emit('input');
    }
  }
}
</script>

<style scoped>

</style>
